import { sendHttpRequest } from "lib/fetcher";
export const getUser = (name: string, role) => {
  // Data Mocked
  return sendHttpRequest({
    method: "get",
    url: "/org/users",
    params: {
      name,
      "page.limit": 20,
      "page.offset": 0,
      role,
    },
  });
};
export const getShiftsByDate = async (startTime, endTime) => {
  const res = await sendHttpRequest({
    method: "get",
    url: `/shift/shifts`,
    params: {
      startTime: startTime,
      endTime: endTime,
    },
  });
  return res;
};
export const createShift = async (
  dispatcherId,
  endedAt,
  startedAt,
  name,
  operateInfo,
  operatorManagerId,
) => {
  return sendHttpRequest({
    method: "post",
    url: "/shift/shifts",
    data: {
      shift: {
        dispatcher: { userId: dispatcherId },
        endedAt,
        startedAt,
        name,
        operateInfo,
        operatorManager: { userId: operatorManagerId },
      },
      isCreate: true,
    },
  });
};
export const updateShift = async (
  id,
  dispatcherId,
  endedAt,
  startedAt,
  name,
  operateInfo,
  operatorManagerId,
) => {
  return sendHttpRequest({
    method: "put",
    url: "/shift/shifts/" + id,
    data: {
      shift: {
        id,
        dispatcher: { userId: dispatcherId },
        endedAt,
        startedAt,
        name,
        operateInfo,
        operatorManager: { userId: operatorManagerId },
      },
      isCreate: false,
    },
  });
};
export const deleteShift = async (id) => {
  return sendHttpRequest({
    method: "delete",
    url: "/shift/shifts/" + id,
  });
};
export const applyTemplate = (selectedDate, templateId) => {
  return sendHttpRequest({
    method: "post",
    url: "/shift/shifts/apply",
    data: {
      selectDates: [selectedDate],
      templateId,
    },
  });
};
